<template>
  <div class="advantage-wrap">
    <div class="top">
      <img class="logo" src="@/assets/images/mobile/good.png">
      <span class="good">我们的优势</span>
    </div>
    <div class="line"></div>
    <div class="content">
      <div class="item">
        <img class="dian" src="@/assets/images/mobile/dian.png" alt="">
        <div class="right">
          <span class="title"> 质量保证 </span>
          <span class="desc mt20">
            <img class="zhi" src="@/assets/images/mobile/zhi.png">
            中鹏矿山机械设备符合各种要求，安全合规，质量经得起考验，性价比高
          </span>
        </div>
      </div>

      <div class="item">
        <img class="dian" src="@/assets/images/mobile/dian.png" alt="">
        <div class="right">
          <span class="title"> 价格保证 </span>
          <span class="desc mt20">我们拥有自己的生产线厂家直供、没有中间价、价格更优惠</span>
        </div>
      </div>

      <img src="@/assets/images/mobile/short.png" class="short" alt="">

      <div class="item">
        <img class="dian" src="@/assets/images/mobile/dian.png" alt="">
        <div class="right">
          <span class="title"> 强大的物流运输服务 </span>

          <span class="desc mt20">
            <img class="car" src="@/assets/images/mobile/car.png">
            专业的物流运输服务公司，线路齐全，运输速度快，确保客户的设备可以更快更安全的到达客户手中，免去了运输不方便的烦恼
          </span>
        </div>
      </div>
      <div class="item">
        <img class="dian" src="@/assets/images/mobile/dian.png" alt="">
        <div class="right">
          <span class="title"> 五星服务支持 </span>
          <span class="desc">
            售前、售中、售后三个阶段对客户实行一对一服务，360°为客户提供服务
            <img class="car" src="@/assets/images/mobile/serve1.png">
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Advantage"
}
</script>

<style lang="less" scoped>
.advantage-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .top {
    margin-top: 0.8rem;
    display: flex;
    .logo {
      width: 1rem;
      height: 1rem;
    }
    .good {
      margin-left: 0.16rem;
      font-size: 0.8rem;
      font-weight: 600;
    }
  }
  .line {
    margin-top: 0.5rem;
    width: 78%;
    height: 0.06rem;
    background: linear-gradient(90deg, #45A6FF 0%, #03FAF9 28.65%, #FFF 50%, #03FAF9 70.31%, #45A6FF 100%);
    border-radius: 0.1rem;
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.32rem;
    .short {
      width: 90%;
      height: 100%;
      margin-top: 0.16rem;
    }
    .item {
      display: flex;
      margin-top: 0.32rem;
      .dian {
        width: 0.8rem;
        height: 0.8rem;
      }
      .right {
        display: flex;
        flex-direction: column;

        .title {
          font-size: 0.6rem;
        }
        .desc {
          display: flex;
          align-items: center;
          font-size: 0.4rem;
          color: #444444;
          .car {
            width: 2.2rem;
            height: 2.2rem;
            margin-right: 0.16rem;
          }
          .zhi {
            width: 1.2rem;
            height: 1.2rem;
            margin-right: 0.16rem;
          }
          .serve {
            width: 2rem;
            height: 2rem;
          }
        }
        .mt20 {
          margin-top: 0.2rem;
        }
      }

    }
  }
}
</style>
